/* assets/briyo.js - generated 2026-09-14. Static component scripts
   moved out of inline <script> blocks for PDP perf. Loaded with defer
   at the end of <body> (layout/theme.liquid). Cart-drawer logic,
   GoKwik, Meta pixel hygiene, and Judge.me's own scripts were
   deliberately NOT moved here - see the PR description. */

/* --- snippets/consultation-modal.liquid --- */
(function () {
  /* ==============================================================
     ENDPOINT — the one place to change.
     Paste the founder's Apps Script web-app deployment URL here
     (looks like https://script.google.com/macros/s/AKfy.../exec).
     While empty, submits show the failure state with the WhatsApp/
     email fallback instead of silently doing nothing.
     ============================================================== */
  var CONSULT_ENDPOINT = 'https://script.google.com/macros/s/AKfycbyJR7JofkXQXcLyNZdrUhNwJAqeSXxqxF5YqgaFsDQ2-WsJ6AqLWeobJ5nzwpfpvAxSwQ/exec';

  var THROTTLE_MS = 30000; // one submit per 30s per browser
  var modal = document.getElementById('ConsultModal');
  if (!modal) return;

  var formWrap = modal.querySelector('[data-consult-form-wrap]');
  var successEl = modal.querySelector('[data-consult-success]');
  var failureEl = modal.querySelector('[data-consult-failure]');
  var form = modal.querySelector('[data-consult-form]');
  var submitBtn = modal.querySelector('[data-consult-submit]');
  var lastTrigger = null;
  var inFlight = false;

  function showPane(pane) {
    [formWrap, successEl, failureEl].forEach(function (el) { el.hidden = (el !== pane); });
  }

  function focusables() {
    return modal.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])');
  }

  /* Scroll lock: position:fixed body with offset save/restore.
     Chosen over overflow:hidden because (a) this page scrolls on <html>
     (document.scrollingElement), so body overflow rules do nothing, and
     (b) iOS Safari ignores overflow:hidden on the scroller entirely -
     the fixed-body technique is the only one that holds on both.
     html's overflow-x: clip is untouched (y-axis only via fixing the
     body). The scrollbar the lock removes is compensated with
     padding-right so desktop layout doesn't jump. */
  var savedScrollY = 0;

  function lockScroll() {
    savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    var scrollbarW = window.innerWidth - document.documentElement.clientWidth;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = -savedScrollY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    if (scrollbarW > 0) b.style.paddingRight = scrollbarW + 'px';
  }

  function unlockScroll() {
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.style.paddingRight = '';
    // Exact restore; 'instant' sidesteps the theme's CSS
    // scroll-behavior: smooth so there's no visible glide.
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({ top: savedScrollY, left: 0, behavior: 'instant' });
    } else {
      window.scrollTo(0, savedScrollY);
    }
  }

  function open(trigger) {
    lastTrigger = trigger || null;
    showPane(formWrap);
    modal.hidden = false;
    lockScroll();
    var first = form.querySelector('input');
    if (first) first.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    modal.hidden = true;
    unlockScroll();
    document.removeEventListener('keydown', onKeydown);
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var els = focusables();
    if (!els.length) return;
    var visible = Array.prototype.filter.call(els, function (el) { return el.offsetParent !== null; });
    if (!visible.length) return;
    var first = visible[0], last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-consult-close]')) close();
    if (e.target.closest('[data-consult-retry]')) showPane(formWrap);
  });

  // Trigger: the PDP consult CTA link. Keep href navigation for no-JS.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-consult-open]');
    if (!trigger) return;
    e.preventDefault();
    open(trigger);
  });

  /* ---- validation ---- */
  function setError(name, show) {
    var input = form.querySelector('[name="' + name + '"]');
    var err = form.querySelector('[data-error-for="' + name + '"]');
    var field = input && input.closest('.consult-field');
    if (err) err.hidden = !show;
    if (field) field.classList.toggle('has-error', !!show);
    if (input) input.setAttribute('aria-invalid', show ? 'true' : 'false');
  }

  function validate() {
    var ok = true;
    var name = form.name.value.trim();
    var phone = form.phone.value.replace(/\D/g, '');
    var email = form.email.value.trim();
    var goal = form.goal.value.trim();
    var consent = form.consent.checked;

    if (!name) { setError('name', true); ok = false; }
    if (!/^[6-9]\d{9}$/.test(phone)) { setError('phone', true); ok = false; }
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setError('email', true); ok = false; }
    if (!goal) { setError('goal', true); ok = false; }
    if (!consent) { setError('consent', true); ok = false; }
    return ok;
  }

  // Clear a field's error as soon as the user edits it.
  form.addEventListener('input', function (e) {
    if (e.target.name) setError(e.target.name, false);
  });
  form.addEventListener('change', function (e) {
    if (e.target.name === 'consent') setError('consent', false);
  });

  // In-field validation.
  // Phone: numeric only, hard-capped at 10 digits while typing/pasting.
  // Pasted numbers like "+91 98765 43210" or "098765 43210" are
  // normalized by dropping the country code / trunk zero.
  form.phone.addEventListener('input', function () {
    var digits = this.value.replace(/\D/g, '');
    if (digits.length > 10 && digits.indexOf('91') === 0) digits = digits.slice(2);
    if (digits.length === 11 && digits.indexOf('0') === 0) digits = digits.slice(1);
    digits = digits.slice(0, 10);
    if (this.value !== digits) this.value = digits;
  });
  // Show the field's own error when leaving it, not only at submit.
  form.phone.addEventListener('blur', function () {
    if (this.value !== '' && !/^[6-9]\d{9}$/.test(this.value)) setError('phone', true);
  });
  form.email.addEventListener('blur', function () {
    var v = this.value.trim();
    if (v !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) setError('email', true);
  });

  /* ---- submit ---- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (inFlight) return;
    if (!validate()) {
      var firstBad = form.querySelector('.has-error input');
      if (firstBad) firstBad.focus();
      return;
    }

    // Honeypot: bots that fill "company" get a fake success, no request.
    if (form.company.value !== '') { showPane(successEl); return; }

    // Throttle
    var now = Date.now();
    var last = 0;
    try { last = parseInt(localStorage.getItem('briyoConsultLast') || '0', 10) || 0; } catch (err) {}
    if (now - last < THROTTLE_MS) { showPane(successEl); return; }

    if (!CONSULT_ENDPOINT) { showPane(failureEl); return; }

    inFlight = true;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';

    var body = new URLSearchParams({
      name: form.name.value.trim(),
      phone: '+91' + form.phone.value.replace(/\D/g, ''),
      email: form.email.value.trim(),
      goal: form.goal.value.trim(),
      company: form.company.value
    });

    fetch(CONSULT_ENDPOINT, { method: 'POST', body: body })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json && json.result === 'ok') {
          try { localStorage.setItem('briyoConsultLast', String(Date.now())); } catch (err) {}
          showPane(successEl);
        } else {
          showPane(failureEl);
        }
      })
      .catch(function () { showPane(failureEl); })
      .finally(function () {
        inFlight = false;
        submitBtn.disabled = false;
        submitBtn.textContent = 'Request my consultation';
      });
  });
})();

/* --- snippets/product-metafield-tabs.liquid --- */
(function() {
  /* -- Desktop tab switcher -- */
  var tabsEl = document.querySelector('.pdp-tabs');
  if (tabsEl) {
    var btns   = tabsEl.querySelectorAll('.pdp-tabs__btn');
    var panels = tabsEl.querySelectorAll('.pdp-tabs__panel');

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var scrollTo = btn.getAttribute('data-scroll-to');
        if (scrollTo) {
          var sec = document.querySelector(scrollTo);
          if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        var panelId = btn.getAttribute('data-panel');
        btns.forEach(function(b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
        panels.forEach(function(p) { p.hidden = true; p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var panel = document.getElementById(panelId);
        if (panel) { panel.hidden = false; panel.classList.add('is-active'); }
      });
    });
  }

  /* -- Mobile accordion -- */
  var accordion = document.querySelector('.product-accordion--mobile');
  if (accordion) {
    var items = accordion.querySelectorAll('.product-accordion__item');

    items.forEach(function(item) {
      if (item.classList.contains('is-active') && !item.classList.contains('product-accordion__item--link')) {
        var body = item.querySelector('.product-accordion__body');
        var content = item.querySelector('.product-accordion__content');
        if (body && content) body.style.height = content.offsetHeight + 'px';
      }
    });

    items.forEach(function(item) {
      var trigger = item.querySelector('.product-accordion__trigger');
      var body    = item.querySelector('.product-accordion__body');
      var content = item.querySelector('.product-accordion__content');
      var scrollTarget = item.getAttribute('data-scroll-to');

      trigger.addEventListener('click', function() {
        if (scrollTarget) {
          var sec = document.querySelector(scrollTarget);
          if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        var isOpen = item.classList.contains('is-active');
        items.forEach(function(i) {
          if (!i.classList.contains('product-accordion__item--link')) {
            var b = i.querySelector('.product-accordion__body');
            i.classList.remove('is-active');
            if (b) b.style.height = '0px';
          }
        });
        if (!isOpen) {
          item.classList.add('is-active');
          if (body && content) body.style.height = content.offsetHeight + 'px';
        }
      });
    });

    window.addEventListener('resize', function() {
      clearTimeout(window._accResize);
      window._accResize = setTimeout(function() {
        var active = accordion.querySelector('.product-accordion__item.is-active');
        if (active && !active.classList.contains('product-accordion__item--link')) {
          var body = active.querySelector('.product-accordion__body');
          var content = active.querySelector('.product-accordion__content');
          if (body && content) body.style.height = content.offsetHeight + 'px';
        }
      }, 100);
    });
  }
})();

/* -- Lab Reports Modal -- */
(function() {
  function openModal(uid) {
    var modal = document.getElementById('lab-modal-' + uid);
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    modal.querySelector('.lab-modal__close').focus();
  }
  function closeModal(modal) {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-open-lab-modal]');
    if (btn) { openModal(btn.getAttribute('data-open-lab-modal')); return; }

    var closeBtn = e.target.closest('.lab-modal__close');
    if (closeBtn) { closeModal(closeBtn.closest('.lab-modal')); return; }

    var backdrop = e.target.closest('.lab-modal__backdrop');
    if (backdrop) { closeModal(backdrop.closest('.lab-modal')); return; }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.lab-modal:not([hidden])');
      if (open) closeModal(open);
    }
  });
})();

/* --- sections/custom-bought-together.liquid --- */
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    var wrapper = document.querySelector('[id^="BoughtTogether-"]');
    if (!wrapper) return;

    function initBoughtTogether(container) {

      var formatMoney = function (cents) {
        return '₹ ' + (cents / 100).toFixed(2).replace(/\.00$/, '');
      };

      var updateTotals = function () {
        var total = 0;
        var totalCompare = 0;
        var items = container.querySelectorAll('.bt-item');

        items.forEach(function (item) {
          var checkbox = item.querySelector('.bt-checkbox');
          var isChecked = checkbox ? checkbox.checked : true;

          if (isChecked) {
            item.classList.remove('disabled');
            var select = item.querySelector('.bt-variant-select');
            var priceElement = item.querySelector('.bt-price');
            var compareElement = item.querySelector('.bt-compare-price');
            var imageElement = item.querySelector('.bt-image-wrap img');

            var currentPrice = 0;
            var currentCompare = 0;

            if (select) {
              var selectedOption = select.options[select.selectedIndex];
              if (selectedOption && selectedOption.dataset.price) {
                currentPrice = parseInt(selectedOption.dataset.price);
                currentCompare = parseInt(selectedOption.dataset.compare) || currentPrice;

                if (imageElement && selectedOption.dataset.image) {
                  imageElement.src = selectedOption.dataset.image;
                }

                if (priceElement) priceElement.innerText = formatMoney(currentPrice);
                if (compareElement) {
                  // 2026-10-21 dark-pattern batch: data-compare carries a labelled
                  // MRP for 1-unit variants only (snippets/price-reference.liquid).
                  if (currentCompare > currentPrice) {
                    compareElement.innerHTML = '<span class="bt-mrp">MRP</span> <s>' + formatMoney(currentCompare) + '</s>';
                    compareElement.style.display = 'inline';
                  } else {
                    compareElement.style.display = 'none';
                  }
                }
              }
            } else if (priceElement && priceElement.dataset.price) {
              currentPrice = parseInt(priceElement.dataset.price);
              currentCompare = compareElement ? parseInt(compareElement.dataset.compare) || currentPrice : currentPrice;
            }

            total += currentPrice;
            totalCompare += currentCompare;
          } else {
            item.classList.add('disabled');
          }
        });

        var totalEl = container.querySelector('.bt-total-price');
        var compareEl = container.querySelector('.bt-total-compare-price[data-bt-compare-row]');

        if (totalEl) {
          totalEl.innerText = formatMoney(total);
          totalEl.classList.add('is-loaded');
        }

        // 2026-10-21 dark-pattern batch: no struck "total" - a sum of MRPs was
        // never a price this combination was sold at.
        if (compareEl) {
          compareEl.hidden = true;
        }
      };

      container.addEventListener('change', function (e) {
        if (e.target.classList.contains('bt-checkbox') || e.target.classList.contains('bt-variant-select')) {
          updateTotals();
        }
      });

      updateTotals();

      var btn = container.querySelector('.bt-add-all');
      var errorMsg = container.querySelector('.bt-error-message');
      var labels = {
        adding: container.dataset.addingLabel,
        added: container.dataset.addedLabel,
        button: container.dataset.buttonLabel,
        error: container.dataset.errorMessage,
      };
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var itemsToAdd = [];
          var items = container.querySelectorAll('.bt-item');

          items.forEach(function (item) {
            var checkbox = item.querySelector('.bt-checkbox');
            var isChecked = checkbox ? checkbox.checked : true;

            if (isChecked) {
              var select = item.querySelector('.bt-variant-select');
              var vid = item.dataset.id;
              if (select) {
                vid = select.value;
              }
              itemsToAdd.push({
                id: parseInt(vid),
                quantity: 1
              });
            }
          });

          if (itemsToAdd.length === 0) return;

          btn.innerText = labels.adding;
          btn.disabled = true;
          if (errorMsg) { errorMsg.hidden = true; errorMsg.textContent = ''; }

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: itemsToAdd })
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Failed to add to cart');
              return response.json();
            })
            .then(function (data) {
              btn.innerText = labels.added;
              btn.classList.add('bt-add-all--success');

              setTimeout(function () {
                btn.innerText = labels.button;
                btn.classList.remove('bt-add-all--success');
                btn.disabled = false;
              }, 2000);

              fetch(window.Shopify.routes.root + 'cart.js')
                .then(function (res) { return res.json(); })
                .then(function (cart) {
                  var cartCounts = document.querySelectorAll('[data-cart-count], .cart-count');
                  cartCounts.forEach(function (count) {
                    count.textContent = cart.item_count;
                  });

                  document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
                  document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
                  document.dispatchEvent(new CustomEvent('cart:build'));

                  setTimeout(function () {
                    var cartIcon = document.querySelector('.js-drawer-open-cart');
                    if (cartIcon) cartIcon.click();

                    if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
                      window.theme.cart.getCart();
                    }

                    if (window.theme && window.theme.Drawers && window.theme.Drawers.cart) {
                      window.theme.Drawers.cart.open();
                    } else if (typeof theme !== 'undefined' && theme.Drawers) {
                      try { theme.Drawers.cart.open(); } catch (e) {}
                    }
                  }, 200);
                });
            })
            .catch(function (error) {
              console.error('Error:', error);
              btn.innerText = labels.button;
              btn.disabled = false;
              if (errorMsg) {
                errorMsg.textContent = labels.error;
                errorMsg.hidden = false;
              }
            });
        });
      }
    }

    // Products come from metafield - always server-rendered, no fetch needed
    initBoughtTogether(wrapper);
  });
})();

/* --- sections/product-recommendations.liquid --- */
(function() {
  function atcFetch(variantId, btn) {
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.classList.add('is-added');
      btn.textContent = '✓ Added!';
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        document.querySelectorAll('[data-cart-count], .cart-count').forEach(function(el) { el.textContent = cart.item_count; });
        ['cart:refresh','cart:updated','cart:build'].forEach(function(ev) {
          document.dispatchEvent(new CustomEvent(ev, { detail: cart }));
        });
        setTimeout(function() {
          var ci = document.querySelector('.js-drawer-open-cart');
          if (ci) ci.click();
        }, 150);
      });
      setTimeout(function() { btn.disabled = false; btn.classList.remove('is-added'); btn.textContent = orig; }, 2400);
    })
    .catch(function() {
      btn.textContent = 'Try again';
      setTimeout(function() { btn.disabled = false; btn.textContent = orig; }, 2000);
    });
  }

  function injectATCButtons(section) {
    section.querySelectorAll('.rec-item-wrap').forEach(function(wrap) {
      if (wrap.querySelector('.rec-atc-btn')) return;
      var variantId = wrap.getAttribute('data-variant-id');
      var available = wrap.getAttribute('data-available') === 'true';
      var card = wrap.querySelector('.minimal-product-card');
      if (!card) return;
      var btn = document.createElement('button');
      btn.className = 'rec-atc-btn';
      btn.type = 'button';
      btn.textContent = available ? 'Add to Cart' : 'Sold Out';
      if (!available) btn.disabled = true;
      else btn.addEventListener('click', function() { atcFetch(variantId, btn); });
      card.appendChild(btn);
    });
  }

  function initSection(section) {
    injectATCButtons(section);

    var area = section.querySelector('.grid-overflow-wrapper');
    var prev = section.querySelector('.rec-arrow--prev');
    var next = section.querySelector('.rec-arrow--next');
    if (area && prev && next) {
      var step = function() { var c = area.querySelector('.rec-item-wrap'); return c ? c.offsetWidth + 12 : 260; };
      prev.addEventListener('click', function() { area.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      next.addEventListener('click', function() { area.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      var ua = function() {
        var sl = area.scrollLeft, max = area.scrollWidth - area.clientWidth;
        prev.style.opacity = sl < 5 ? '0.3' : '1';
        next.style.opacity = sl > max - 5 ? '0.3' : '1';
      };
      area.addEventListener('scroll', ua, { passive: true });
      ua();
    }
  }

  /* theme.js's ProductRecommendations custom element (assets/theme.js,
     class ProductRecommendations) fetches the real recommendation grid
     and injects it with `this.placeholder.innerHTML = recommendations.innerHTML`
     - i.e. INSIDE the same .product-recommendations-placeholder div the
     loading skeleton used, not alongside it. That div's own CSS
     (aria-hidden="true" in the Liquid, pointer-events:none in this
     section's <style> block) was only ever meant to keep the skeleton
     out of the way while it's still loading - theme.js never clears
     either attribute once real product cards replace it, so every
     rendered card silently became unclickable (confirmed live:
     elementFromPoint on a card's link returned the wrapper div, not the
     link, because pointer-events:none on this ancestor blocks all
     descendants regardless of their own pointer-events value). */
  document.addEventListener('recommendations:loaded', function(e) {
    var section = e.detail && e.detail.section;
    if (!section) return;
    var ph = section.querySelector('.product-recommendations-placeholder');
    if (!ph) return;
    ph.style.pointerEvents = 'auto';
    ph.removeAttribute('aria-hidden');
  });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product-recommendations-section').forEach(initSection);
  });
  document.addEventListener('shopify:section:load', function(e) {
    var s = e.target.querySelector('.product-recommendations-section');
    if (s) initSection(s);
  });
  var obs = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        var s = (node.closest && node.closest('.product-recommendations-section')) ||
                (node.querySelector && node.querySelector('.product-recommendations-section'));
        if (s) initSection(s);
      });
    });
  });
  document.querySelectorAll('product-recommendations').forEach(function(el) {
    obs.observe(el, { childList: true, subtree: true });
  });
})();

/* --- snippets/product-template.liquid --- */
/* Contents and days chips track the selected pack:
                             per-unit bases x pack quantity. Reads the active
                             booster-pack card's option1 on the theme's
                             variant:change event (same source the sticky ATC
                             bar uses), with a click fallback for safety. */
                          (function () {
                            if (window.__briyoSpecChips) return;
                            window.__briyoSpecChips = true;
                            var update = function () {
                              var active = document.querySelector('.booster-pack__card--active');
                              var opt1 = active ? active.getAttribute('data-option1-value') || '' : '';
                              var qty = parseInt(opt1.replace('Pack of ', ''), 10) || 1;
                              document.querySelectorAll('[data-chip-contents]').forEach(function (el) {
                                var base = parseInt(el.getAttribute('data-base-num'), 10);
                                var rest = el.getAttribute('data-rest') || '';
                                if (!base) return;
                                if (qty > 1 && rest.indexOf('per box') !== -1) {
                                  el.textContent = (base * qty) + ' ' + rest.replace('per box', '').trim() + ' (' + qty + ' boxes)';
                                } else {
                                  el.textContent = (base * qty) + rest;
                                }
                              });
                              document.querySelectorAll('[data-chip-days]').forEach(function (el) {
                                var dpu = parseInt(el.getAttribute('data-days-per-unit'), 10);
                                if (dpu) el.textContent = (dpu * qty) + '-day supply';
                              });
                            };
                            document.addEventListener('variant:change', update);
                            document.addEventListener('click', function (e) {
                              if (e.target.closest('.booster-pack__card, .booster-pack__pill')) {
                                setTimeout(update, 50);
                              }
                            });
                          })();
